<mat-toolbar class="main-header">
  <button mat-icon-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>Partidos</span>
  <span class="header-spacer"></span>
  <button
    mat-stroked-button
    type="button"
    class="sync-button"
    [disabled]="syncing"
    (click)="syncMatches()"
  >
    <mat-icon>{{ syncing ? "hourglass_top" : "sync" }}</mat-icon>
    <span>{{ syncing ? "Sincronizando" : "Sincronizar" }}</span>
  </button>
</mat-toolbar>

<div class="matches-content">
  <app-matches-list mode="results"></app-matches-list>
</div>

<div class="matches-save-bar">
  <button class="save-btn" type="button" (click)="save()">
    <mat-icon>save</mat-icon>
    Guardar resultados
  </button>
</div>

<block-ui></block-ui>
